<script>
import ListViewTemplate from './ListViewTemplate'

import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import feedbackMixin from '../mixins/feedback'
import listViewMixin from '../mixins/list-view'
import exportFileMixin from "../mixins/export-file";

Vue.use(VueAxios, axios);

export default {
	name: 'Dictionary',
	mixins: [feedbackMixin, listViewMixin, exportFileMixin],
	extends: ListViewTemplate,
	data() {
		return {
			primaryKey: 'NDC Code LU',
			columns: [
				{
					name: 'NDC Code LU',
					displayName: 'NDC',
					sort: 0
				},
				{
					name: 'CSA Schedule LU',
					displayName: 'Sch',
					searchName: 'Schedule',
					sort: 0
				},
				{
					name: 'Trade Name Final LU',
					displayName: 'Trade Name',
					sort: 0
				},
				{
					name: 'Strength',
					displayName: 'Strength',
					sort: 0
				},
				{
					name: 'Package Size Converted LU',
					displayName: 'Qty',
					sort: 0,
					align: 'center'
				},
				{
					name: 'Package Size UoM LU',
					displayName: 'UoM',
					sort: 0,
					align: 'center'
				},
				{
					name: 'ARCOS_Dictionary::Drug Code Final',
					displayName: 'Drug Code',
					sort: 0
				},
				{
					name: 'ARCOS_Dictionary::Ingredient Base Weight Final',
					displayName: 'Base Weight',
					sort: 0
				},
				{
					name: 'Date Created',
					displayName: 'Creation Date',
					sort: 0
				},
				{
					name: 'Form',
					displayName: 'Form',
					sort: 0
				},
				{
					name: 'Ingredient Name LU',
					displayName: 'Ingredient Name',
					sort: 0
				},
				{
					name: 'Package Description',
					displayName: 'Package Description',
					sort: 0
				},
				{
					name: 'Bulk Raw Liquid LU',
					displayName: 'Bulk Liquid',
					sort: 0
				},
				{
					name: 'Bulk Raw Powder LU',
					displayName: 'Bulk Powder',
					sort: 0
				},
				{
					name: 'Bulk Dosage Formulation LU',
					displayName: 'Bulk Dosage',
					sort: 0
				},
				{
					name: 'Bulk Solutions LU',
					displayName: 'Bulk Solutions',
					sort: 0
				},
				{
					name: 'Trade Packages',
					displayName: 'Trade Pack',
					sort: 0
				}
			],
			fields: [
				{
					key: 'NDC Code LU',
					label: 'NDC',
					sortable: true,
					stickyColumn: true
				},
				{
					key: 'CSA Schedule LU',
					label: 'Sch',
					searchName: 'Schedule',
					sortable: true
				},
				{
					key: 'Trade Name Final LU',
					label: 'Trade Name',
					sortable: true
				},
				{
					key: 'Strength',
					label: 'Strength',
					sortable: true
				},
				{
					key: 'Package Size Converted LU',
					label: 'Qty',
					sortable: true,
					align: 'center'
				},
				{
					key: 'Package Size UoM LU',
					label: 'UoM',
					sortable: true,
					align: 'center'
				},
				{
					key: 'ARCOS_Dictionary::Drug Code Final',
					label: 'Drug Code',
					sortable: true
				},
				{
					key: 'ARCOS_Dictionary::Ingredient Base Weight Final',
					label: 'Base Weight',
					sortable: true
				},
				{
					key: 'Date Created',
					date: true,
					label: 'Creation Date',
					sortable: true
				},
				{
					key: 'Form',
					label: 'Form',
					sortable: true
				},
				{
					key: 'Ingredient Name LU',
					label: 'Ingredient Name',
					sortable: true
				},
				{
					key: 'Package Description',
					label: 'Package Description',
					sortable: true
				},
				{
					key: 'Bulk Raw Liquid LU',
					label: 'Bulk Liquid',
					sortable: true
				},
				{
					key: 'Bulk Raw Powder LU',
					label: 'Bulk Powder',
					sortable: true
				},
				{
					key: 'Bulk Dosage Formulation LU',
					label: 'Bulk Dosage',
					sortable: true
				},
				{
					key: 'Bulk Solutions LU',
					label: 'Bulk Solutions',
					sortable: true
				},
				{
					key: 'Trade Packages',
					label: 'Trade Pack',
					sortable: true
				}
			],
			headerTitle: 'NDC Dictionary',
			restEntity: 'dictionaries',
			restDetailEntity: 'dictionary',
			hasDetailColumn: false,
			leftmostColumn: 'cell(NDC_Code_LU)'

		}
	},
}
</script>
<style scoped>

</style>